import { AccountFilterKey } from '../domain';
import { useSetFilter } from '../../filter';

export const useSetAccountFilter = () => {
  return useSetFilter(AccountFilterKey, 'accountFilter', true);
};
